import React, { useContext, useEffect, useRef, useState } from "react";
import "./LendingLeads.css";
import { ProfileUpdate } from "../../App";
import { API } from "../../constants/Api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
function LaProfile() {
  const laId = localStorage.getItem("laId");

  const token = localStorage.getItem("token");
  const [agentEmail, setEmail] = useState("");
  const [agentPhone, setPhone] = useState("");
  const { profileUpdateState, setProfileUpdateState } =
    useContext(ProfileUpdate);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getUserInfo = async () => {
      try {
        const response = await fetch(
          `${API}/auth/lendingAgents/get-byid/${laId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const json = await response.json();

        if (response.ok) {
          setEmail(json.lendingAgent.email);
          setPhone(json.lendingAgent.phoneNumber);
          // setEmployerInfo(json.lendingAgent.licenseInfo.length > 0 ? json.lendingAgent.licenseInfo.employerInfo : "")
          // setLicenseNumber(json.lendingAgent.licenseInfo.length > 0 ? json.lendingAgent.licenseInfo.licenseNumber : "")
          // setAddress(json.lendingAgent.officeAddress.length > 0 ? json.lendingAgent.officeAddress.address : "")
          setEmployerInfo(json.lendingAgent.licenseInfo[0]?.employerInfo || "")
          setLicenseNumber(json.lendingAgent.licenseInfo[0]?.licenseNumber || "")
          setAddress(json.lendingAgent.officeAddress[0]?.address || "")
        }
      } catch (error) {
        toast.error(error.message);
      }
    };

    getUserInfo();
  }, [profileUpdateState]);

  const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [zipCode, setCode] = useState("");
  
    const fileRef = useRef(null);
  
    function formValidations() {
      if (employerInfo.length < 1) {
        toast.error("Employer Name is required");
        return false;
      }
  
      if (address.length < 1) {
        toast.error("Address is required");
        return false;
      }
   
      if (licenseNumber.length < 1) {
        toast.error("Business License is required");
        return false;
      }
 
  
      // if (file) {
      //   if((file.size / 1000000) > 1){
      //     toast.error("File should be less than 1 MB");
      //     return false;
      //   }
      // } else {
      //   toast.error("Please Upload File");
      //   return false;
      // }
      return true;
    }
      // if (city.length < 1) {
      //   toast.error("City is required");
      //   return false;
      // }
      // if (state.length < 1) {
      //   toast.error("State is required");
      //   return false;
      // }
      // if (zipCode.length < 1) {
      //   toast.error("Zip Code is required");
      //   return false;
      // }
  
    // const handleSubmit = async (e) => {
    //   e.preventDefault();
  
    //   const validate = await formValidations()
  
    //   if(validate){
    //     navigate("/license-info-page-2", { state: { id: id , officeAddress: {
    //       address: address,
    //       city: city,
    //       state: state,
    //       zipCode: zipCode
    //     }} });
    //   }
  
    
    // };
      const [licenseNumber, setLicenseNumber] = useState("");
      const [employerInfo, setEmployerInfo] = useState("");
   
      const [businessLicense, setBusinessLicense] = useState("");
  
      const [name, setName] = useState("");
      const [size, setSize] = useState("");
      const navigate = useNavigate();  const [file, setPdf] = useState(null);
      const handleChange = (e) => {
        const file = e.target.files[0];
        if (file) {
          setPdf(file);
          console.log(file);
          setName(file.name);
          setSize((file.size / 1000000).toFixed(2));
        }
      };
      const handleUploadClick = () => {
        fileRef.current.click();
      };
      const removePdf = () => {
        setPdf(null);
        setName("");
        fileRef.current.value = null; // Clear the file input
      };
      const handleSubmit = async (e) => {
        e.preventDefault();
        const isValid = await formValidations();
    
        const licenseInfo = {
        
          licenseNumber: licenseNumber,
          employerInfo: employerInfo,
          // businessLicense: businessLicense,
        };
        const officeAddress = {
          address: address,
        
        }
    
        if (isValid) {
          const formData = new FormData();
          formData.append("officeAddress", JSON.stringify(officeAddress));
          formData.append("licenseInfo", JSON.stringify(licenseInfo));
          formData.append("file", file);
    
          setLoading(true);
          const loadtingToast = toast.loading("Submitting Details...");
          try {
            const response = await fetch(
              `${API}/auth/lendingAgents/update-lendingAgent/${laId}`,
              {
                method: "PUT",
                body: formData,
              }
            );
            const json = await response.json();
            if (response.ok) {
              setLoading(false);
              toast.dismiss(loadtingToast);
             
              toast.success("Information Updated successfully");
    
            } else {
              setLoading(false);
              toast.dismiss(loadtingToast);
              toast.error(json.message);
            }
          } catch (error) {
            setLoading(false);
            toast.dismiss(loadtingToast);
            toast.error(error.message);
          } finally {
            setLoading(false);
          }
        }
      };
      const [isMobile, setIsMobile] = useState(false);
        useEffect(() => {
          const handleResize = () => {
            setIsMobile(window.innerWidth <= 600);
          };
      
          handleResize();
      
          window.addEventListener("resize", handleResize);
          return () => {
            window.removeEventListener("resize", handleResize);
          };
        }, []);
  return (
    <div className="user-profile">
      <h2 className="user-layout-page-heading">
        Profile Info
      </h2>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 px-0 py-1">
            <hr className="text-white" style={{ opacity: "0.05" }} />
          </div>
         
          <div className="col-lg-7 px-0 py-1">
            <p className="user-profile-picture">Account Details</p>

            <input
              type="email"
              className="form-control user-profile-input-field"
              id="exampleInputPassword1"
              placeholder="Email address"
              value={agentEmail}
              readOnly

              // onChange={(e) => setEmail(e.target.value)}
            />
              {isMobile ? (
              <input
                type="tel"
                className="form-control user-profile-input-field"
                id="userPhone"
                placeholder="Phone number"
                value={`+1 ${agentPhone}`} // Display "+1" prefix
                readOnly
              />
            ) : (
              <div className="user-profile-phone-number-group">
                <button className="user-profile-phone-code">+1</button>
                <input
                  type="number"
                  className="form-control user-profile-phone-field"
                  id="exampleInputPassword1"
                  placeholder="Phone Number"
                  value={agentPhone}
                  readOnly
                  // onChange={(e) => setPhone(e.target.value)}
                />
              </div>
            )}
          </div>
          <div className="col-12 px-0 py-1">
            <hr className="text-white" style={{ opacity: "0.05" }} />
          </div>
          <div className="col-md-7 px-0 mx-0">
          <p className="user-profile-picture">Office And License Information</p>
              <input
                type="text"
                className="form-control user-profile-input-field"
                id="exampleInputPassword1"
                placeholder="Employer Name"
                // onChange={(e) => setEmployerInfo(e.target.value)}
                value={employerInfo}
                readOnly
              />
              <input
                type="text"
                className="form-control user-profile-input-field"
                id="exampleInputEmail1"
                placeholder="Office Address"
                aria-describedby="emailHelp"
                // onChange={(e) => setAddress(e.target.value)}
                value={address}
                readOnly
              />

              {/* <input
                type="text"
                className="form-control agent-register-input-field"
                id="exampleInputPassword1"
                placeholder="City"
                onChange={(e) => setCity(e.target.value)}
              />
              <input
                type="text"
                className="form-control agent-register-input-field"
                id="exampleInputPassword1"
                placeholder="State"
                onChange={(e) => setState(e.target.value)}
              />
              <input
                type="text"
                className="form-control agent-register-input-field"
                id="exampleInputPassword1"
                placeholder="Zip Code"
                onChange={(e) => setCode(e.target.value)}
              /> */}
              <input
                type="text"
                className="form-control user-profile-input-field"
                id="exampleInputPassword1"
                placeholder="License Number Of Business"
                // onChange={(e) => setLicenseNumber(e.target.value)}
                value={licenseNumber}
                readOnly
              />

              {/* <input
                type="text"
                className="form-control agent-register-input-field"
                id="exampleInputPassword1"
                placeholder="Business License"
                onChange={(e) => setBusinessLicense(e.target.value)}
              /> */}
              {/* <p className="schedule-tour-span">Letter of Authorization</p>
              <div className="schedule-tour-pdf-container">
                {file ? (
                  <div className="schedule-tour-pdf-card">
                    <img
                      src="/img/pdf-preview.svg"
                      className="img-fluid"
                      alt=""
                    />
                    <span
                      style={{
                        color: "#ffffff",
                        fontFamily: "Degular-Light",
                        opacity: "0.7",
                      }}
                    >
                      {name.slice(0, 5)}.pdf ({size}mb)
                    </span>
                    <span
                      onClick={removePdf}
                      role="button"
                      className="badge rounded-circle text-bg-light pdf-close"
                    >
                      X
                    </span>
                  </div>
                ) : (
                  <>
                    <div
                  role="button"
                  onClick={handleUploadClick}
                  className="schedule-tour-pdf-card"
                >
                  <img
                    src="/img/plus-upload.svg"
                    className="img-fluid"
                    alt=""
                  />
                  <span
                    style={{
                      color: "#ffffff",
                      fontFamily: "Degular-Light",
                      opacity: "0.7",
                    }}
                  >
                    Upload PDF
                  </span>
                </div>
                  </>
                )}

              
                <input
                  ref={fileRef}
                  hidden
                  type="file"
                  accept=".pdf"
                  onChange={handleChange}
                />
              </div> */}
              {/* <button
                onClick={handleSubmit}
                className="btn agent-register-button"
              >
                Update
              </button> */}
        
          </div>
        </div>
      </div>
    </div>
  );
}

export default LaProfile;
